import React, { useState } from "react"
import { withRouter } from "react-router-dom"
import { useQuery, useMutation } from "@apollo/client"
import {
  REVIEWS_QUERY,
  ACCOUNT_REVIEWDELETE_MUTATION,
  PRODUCT_QUERY,
} from "../../../../../Config/Queries"

import styled, { css } from "styled-components"
import Button from "../../../../Buttons"
import Link from "../../../../Links"
import { Container, Ready } from "../../../../../styles/styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown } from "@fortawesome/pro-regular-svg-icons"
import Item from "./Item"

const SContainer = styled(Container)`
  ${({ theme }) => {
    return css`
      padding: 0;
      .star {
        padding: 0.1rem;
        ::before {
          content: "\f005";
          color: #bbb;
          font-size: ${theme.fonts.size.base};
          font-family: ${theme.fonts.family.fontAwesomeS};
        }
      }
      .star_on {
        padding: 0.1rem;
        ::before {
          content: "\f005";
          color: ${theme.colors.primary};
          font-size: ${theme.fonts.size.base};
          font-family: ${theme.fonts.family.fontAwesomeS};
        }
      }
      .title {
        padding: ${theme.paddings.base};
        border-bottom: solid 2px #eee;
        font-size: 15px;
      }
      .review_top {
        padding: ${theme.paddings.base} ${theme.paddings.lg};
      }
      .review_bottom {
        border-top: solid 1px #eee;
        padding: ${theme.paddings.base};
      }
    `
  }}
`
const ReviewList = styled.div`
  ${({ theme }) => {
    return css`
      ul {
        margin-top: ${theme.margins.base};
        li {
          padding: 0 ${theme.paddings.base};
          margin-bottom: ${theme.margins.base};
          border-radius: 5px;
        }
      }
    `
  }}
`

function Review({ history, match, location, ticketProductReviews, uri }) {
  const id = match.params.id

  const [items, setItems] = useState(ticketProductReviews)
  const [page, setPage] = useState(2)
  const first = 10
  const skip = first * (page - 1)
  const [loadmore, setLoadmore] = useState(false)

  const { data, loading, refetch } = useQuery(REVIEWS_QUERY, {
    // fetchPolicy: "network-only",
    variables: {
      ticketProduct: id,
      orderBy: "id_DESC",
      skip: skip,
      first: first,
    },
  })

  const [reviewDeleteMutation] = useMutation(ACCOUNT_REVIEWDELETE_MUTATION, {
    refetchQueries: () => [
      {
        query: PRODUCT_QUERY,
        variables: {
          productType: "Product",
          id,
        },
      },
    ],
  })

  const onDelete = async (id) => {
    if (!window.confirm("선택한 선물후기를 삭제하시겠습니까?")) {
      return
    }

    try {
      const {
        data: { TicketAccountReviewDelete },
      } = await reviewDeleteMutation({
        variables: { id },
      })

      if (TicketAccountReviewDelete) {
        setItems([...items.filter((item) => item.id !== id)])
      }
    } catch (e) {
      console.log(e)
    }
  }

  const handleLoadMore = () => {
    setLoadmore(true)
    setPage(page + 1)
    refetch()
    if (!loading && data.TicketProductReviewList.ticketProductReviews) {
      setItems(items.concat(data.TicketProductReviewList.ticketProductReviews))
    }
    setLoadmore(false)
  }

  return (
    <>
      <SContainer>
        <div className="review_top">
          <Link
            color="primary"
            width="full"
            border="solid"
            size="sm"
            to="/account/completeReviews"
          >
            내 선물 후기 보기
          </Link>
        </div>
        <div className="title">선물후기</div>
        <ReviewList>
          <>
            {items.length > 0 ? (
              <>
                <ul>
                  {items.map((item, index) => {
                    return (
                      <li key={index}>
                        <Item item={item} uri={uri} onDelete={onDelete} />
                      </li>
                    )
                  })}
                </ul>
                {!loadmore &&
                  !loading &&
                  data.TicketProductReviewList.ticketProductReviews.length >
                    0 && (
                    <div className="review_bottom">
                      <Button
                        color="white"
                        border="radius"
                        width="full"
                        onClick={() => handleLoadMore()}
                      >
                        <FontAwesomeIcon icon={faAngleDown} />
                        &nbsp; 더보기
                      </Button>
                    </div>
                  )}
              </>
            ) : (
              <Ready>
                <div className="list_none">등록된 선물후기가 없습니다.</div>
              </Ready>
            )}
          </>
        </ReviewList>
      </SContainer>
    </>
  )
}
export default withRouter(Review)
